import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const ReferNgoConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/refer-ngo",
    component: React.lazy(() => import("./refer-ngo")),
  },
];
